// extracted by mini-css-extract-plugin
export default {"previewImageWrapper":"UploadImage_previewImageWrapper__pCEWQ","previewImage":"UploadImage_previewImage__Lg8YI"};